import { RequestGatewayPlugin } from "../../../type";
import { isServer } from "../../../utils";

const replaceDemoTradingUrlPlugin: RequestGatewayPlugin = {
  name: "replaceDemoTradingUrlPlugin",
  type: "request",
  apply(config, options, urls) {
    const { baseUrl, demoTradingUrl } = options;
    if (
      isServer() &&
      (config.isDemoTrading || Number(config.headers?.isDemoTrading) > 0)
    ) {
      config.url = config.url?.replace(baseUrl, demoTradingUrl);
    }

    return config;
  },
};

export default replaceDemoTradingUrlPlugin;
